module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "BIBLIO"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xviii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rBIBLIO"
    }
  }, [_vm._v("BIBLIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "ahaft",
    attrs: {
      "id": "BIBLIO.1"
    }
  }, [_vm._v("I. A NOTE ON THE USE OF PRIMARY SOURCES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Unless otherwise noted, I have used "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Novum Testamentum Graece")]), _vm._v(" (ed. Kurt Aland, Johannes Karavidopoulos, Carlo M. Martini, and Bruce M. Metzger; 27th ed., 1993) for the text of Romans and other NT literature, "), _c('i', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(" (ed. K. Elliger and W. Rudolf, 1977) for the Hebrew OT, "), _c('i', [_vm._v("Septuaginta")]), _vm._v(" (ed. A. Rahlfs, 1971) for the Septuagint, "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die Texte aus Qumran")]), _vm._v(" (ed. E. Lohse, 1964) for the Dead Sea Scrolls, the Loeb Classical Library editions for the works of Josephus and Philo, "), _c('i', [_vm._v("The Oxford Annotated Apocrypha")]), _vm._v(" ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.RSV"
    }
  }, [_vm._v("RSV")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TRANS"
    }
  }, [_vm._v("trans.")]), _vm._v(", 1957) for English translations of the Apocrypha, and "), _c('i', [_vm._v("The Old Testament Pseudepigrapha")]), _vm._v(" (ed. J. Charlesworth; 2 vols., 1983, 1985) for English translations of the Pseudepigrapha.")]), _vm._v(" "), _c('p', [_vm._v("I have cited texts from the OT according to the versification of the English translations, even when the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MT"
    }
  }, [_vm._v("MT")]), _vm._v(" or "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LXX"
    }
  }, [_vm._v("LXX")]), _vm._v(" verse number differs.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BIBLIO.2"
    }
  }, [_vm._v("II. A NOTE ON THE USE OF SECONDARY SOURCES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The interpreter of Romans is faced with the danger that the text of what Paul himself wrote will become obscured by the reams and reams of material that other people have written about the text. Thomas Hobbes is reputed to have said, “If I read as many books as most men do, I would be as dull-witted as they are.” Certainly it is easy for the interpreter of Scripture to substitute broad reading in books about the text for deep reading in the text itself. In no book of the Bible is this more of a temptation than in Romans, and I hope I have not succumbed to it.")]), _vm._v(" "), _c('p', [_vm._v("In any case, I have tried to keep the focus on the text while, at the same time, interacting with as much of the secondary literature as possible. "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xix"
    }
  }), _vm._v("Even here, however, I have been quite selective, citing scholars who are representative of a particular view or who have argued a view particularly well. With respect to this point, the reader should note the difference between a simple reference to a work and a reference preceded by “see especially.” The former indicates nothing more than that the work in question is representative of those who argue the particular position mentioned, but the latter means that the work in question provides a particularly good argument for the point in question.")]), _vm._v(" "), _c('p', [_vm._v("I have cited commentaries by the last name of the commentator only; the reader may assume, unless noted, that the reference is to the commentator’s notes on the relevant verse. I have cited several other frequently used volumes in the same way; these are listed under “Other Significant Works” below.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BIBLIO.3"
    }
  }, [_vm._v("III. COMMENTARIES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The following list of commentaries is far from exhaustive: Romans, by virtue of its theological importance, has attracted uncountable numbers of commentators (Cranfield [1.30–44] has a particularly good survey of commentaries up to 1973). These range from technical, scholarly tomes, replete with Latin and Greek and extensive interaction with other scholars, to homilies designed to apply, rather than analyze, the message of the letter.")]), _vm._v(" "), _c('p', [_vm._v("The reader will find few references to the second type because such books, by their very nature, say little new about the meaning of the text. A noted exception, however—if indeed they belong in this category at all—are the edited sermons of D. M. Lloyd-Jones. His very relevant homiletical applications grow out of insightful, theologically informed exegesis, and the reader can see from the notes how much his exegesis has informed my own thinking about the text.")]), _vm._v(" "), _c('p', [_vm._v("On the other hand, I have consulted as many of those works on Romans that might be accurately termed “commentary” as I could lay my hands on. Realizing early on in my work that it was both impractical and unnecessary to cite all these works consistently—for there is much repetition of argument and conclusion—I selected twelve commentators for particularly careful study. Three factors informed my selection: exegetical excellence, theological sophistication, and representative significance. These commentaries may be called—to borrow a phrase from textual criticism—the “constant witnesses” in my commentary, and they are preceded in the list that follows with and asterisk (*). I regard these scholars as my exegetical “sparring partners,” and I refer the reader to them consistently.")]), _vm._v(" "), _c('div', {
    staticClass: "references"
  }, [_c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xx"
    }
  }), _vm._v("Achtemeier, Paul J. "), _c('i', [_vm._v("Romans.")]), _vm._v(" Interpretation: A Bible Commentary for Teaching and Preaching. Atlanta: John Knox, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Alford, Henry. "), _c('i', [_vm._v("The Greek Testament.")]), _vm._v(" 4 vols. 1845–60. Reprint. Chicago: Moody, 1958.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Althaus, Paul. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an der Römer übersetzt und erklärt.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NTD"
    }
  }, [_vm._v("NTD")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ambrosiaster, in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.PL"
    }
  }, [_c('i', [_vm._v("PL")])]), _vm._v(" 17.45–184.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Augustine. "), _c('i', [_vm._v("Augustine on Romans: Propositions from the Epistle to the Romans and Unfinished Commentary on the Epistle to the Romans.")]), _vm._v(" Chico, CA: Scholars, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Barclay, William. "), _c('i', [_vm._v("The Letter to the Romans.")]), _vm._v(" The Daily Study Bible. Edinburgh: St. Andrew, 1957.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Barrett, C. K. "), _c('i', [_vm._v("A Commentary on the Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HNTC"
    }
  }, [_vm._v("HNTC")]), _vm._v(". San Francisco: Harper & Row, 1957.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Barth, Karl. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" London: Oxford University, 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. "), _c('i', [_vm._v("A Shorter Commentary on Romans.")]), _vm._v(" Richmond: John Knox, 1959. (Cited as "), _c('i', [_vm._v("Shorter.")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Baulès, R. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("L’Evangile puissance de Dieu.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.LD"
    }
  }, [_vm._v("LD")]), _vm._v(" 53. Paris: Cerf, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bengel, J. A. "), _c('i', [_vm._v("Gnomon of the New Testament.")]), _vm._v(" 5 vols. 1742. Reprint. Edinburgh: T & T Clark, 1860.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Best, Ernest. "), _c('i', [_vm._v("The Letter of Paul to the Romans.")]), _vm._v(" Cambridge Bible Commentary. Cambridge: Cambridge University, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Black, Matthew. "), _c('i', [_vm._v("Romans.")]), _vm._v(" NCB. London: Oliphants, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Boylon, Patrick. "), _c('i', [_vm._v("St. Paul’s Epistle to the Romans.")]), _vm._v(" Dublin: M. H. Gill, 1934.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bruce, F. F. "), _c('i', [_vm._v("The Letter of Paul to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.TNTC"
    }
  }, [_vm._v("TNTC")]), _vm._v(". Grand Rapids: Eerdmans, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Brunner, Emil. "), _c('i', [_vm._v("The Letter to the Romans: A Commentary.")]), _vm._v(" Philadelphia: Westminster, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Calvin, John. "), _c('i', [_vm._v("Commentaries on the Epistle of Paul the Apostle to the Romans.")]), _vm._v(" 1540. Reprint. Grand Rapids: Eerdmans, 1947.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Chrysostom, John. "), _c('i', [_vm._v("Homilies on Romans. PG")]), _vm._v(" 60.391–682; "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NPNF"
    }
  }, [_c('i', [_vm._v("NPNF")])]), _vm._v(" 11.335–564.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Cranfield, C. E. B. "), _c('i', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ICC"
    }
  }, [_vm._v("ICC")]), _vm._v(", "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.N.S"
    }
  }, [_vm._v("n.s.")]), _vm._v(" 2 vols. Edinburgh: T & T Clark, 1975, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Denney, James. “St. Paul’s Epistle to the Romans.” In "), _c('i', [_vm._v("The Expositor’s Greek New Testament,")]), _vm._v(" vol. 2. 1904. Reprint. Grand Rapids: Eerdmans, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dodd, C. H. "), _c('i', [_vm._v("The Epistle of Paul to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MNTC"
    }
  }, [_vm._v("MNTC")]), _vm._v(". New York: Harper and Bros., 1932.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Dunn, James D. G. "), _c('i', [_vm._v("Romans 1–8, Romans 9–16.")]), _vm._v(" Word Biblical Commentary. Waco, TX: Word, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxi"
    }
  }), _vm._v("*Fitzmyer, Joseph. "), _c('i', [_vm._v("Romans: A New Translation with Introduction and Commentary.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.AB"
    }
  }, [_vm._v("AB")]), _vm._v(". New York: Doubleday, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———. “The Letter to the Romans.” In "), _c('i', [_vm._v("The Jerome Biblical Commentary.")]), _vm._v(" Ed. Raymond E. Brown, Joseph A. Fitzmyer, and Roland E. Murphy. Englewood Cliffs, NJ: Prentice-Hall, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Garvie, Alfred E. "), _c('i', [_vm._v("Romans.")]), _vm._v(" The Century Bible. London: Caxton, "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.N.D"
    }
  }, [_vm._v("n.d.")])]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gaugler, E. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief.")]), _vm._v(" Prophezei. 2 vols. Zurich: Zwingli, 1945, 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gifford, E. H. "), _c('i', [_vm._v("The Epistle of St. Paul to the Romans.")]), _vm._v(" London: John Murray, 1886.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Godet, Frederic Louis. "), _c('i', [_vm._v("Commentary on Romans.")]), _vm._v(" 1879. Reprint. Grand Rapids: Kregel, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gore, Charles. "), _c('i', [_vm._v("St. Paul’s Epistle to the Romans. A Practical Exposition.")]), _vm._v(" 2 vols. London: John Murray, 1899.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Haldane, Robert. "), _c('i', [_vm._v("Exposition of the Epistle to the Romans.")]), _vm._v(" 1839. Reprint. London: Banner of Truth, 1958.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrison, Everett F. “Romans.” In "), _c('i', [_vm._v("The Expositor’s Bible Commentary,")]), _vm._v(" vol. 10. Grand Rapids: Zondervan, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Harrisville, Roy A. "), _c('i', [_vm._v("Romans.")]), _vm._v(" Augsburg Commentary on the New Testament. Minneapolis: Augsburg, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hendriksen, William. "), _c('i', [_vm._v("Exposition of Paul’s Epistle to the Romans.")]), _vm._v(" 2 vols. Grand Rapids: Baker, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hodge, Charles. "), _c('i', [_vm._v("Commentary on the Epistle to the Romans.")]), _vm._v(" 1886. Reprint. Grand Rapids: Eerdmans, 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Huby, J. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Saint Paul: Epître aux Romains.")]), _vm._v(" Ed. Stanilas Lyonnet. Paris: Beauchesne, 1957.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Johnson, Alan F. "), _c('i', [_vm._v("Romans: The Freedom Letter.")]), _vm._v(" Everyman’s Bible Commentary. Rev. ed. 2 vols. Chicago: Moody, 1984, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Käsemann, Ernst. "), _c('i', [_vm._v("Commentary on Romans.")]), _vm._v(" Grand Rapids: Eerdmans, 1980 ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ET"
    }
  }, [_vm._v("ET")]), _vm._v(" of "), _c('i', [_vm._v("An die Römer")]), _vm._v(" [Tübingen: Mohr, 1980]).")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kirk, K. E. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" Clarendon Bible. Oxford: Clarendon, 1937.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Knox, John. “The Epistle to the Romans.” "), _c('i', [_vm._v("IB,")]), _vm._v(" vol. 9. New York: Abingdon, 1954.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Kuss, Otto. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief.")]), _vm._v(" 3 vols. Regensburg: Pustet, 1963–78.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lagrange, M.-J. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Saint Paul: Epître aux Romains.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.EBIB"
    }
  }, [_vm._v("Ebib")]), _vm._v(". Paris: Gabalda, 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lapide, Cornelius à. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Commentaria in Epistolarum ad Romanos Commentarii. Sacram Scriptorum,")]), _vm._v(" vol. 9. 1614. Reprint. Paris, 1859.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Leenhardt, Franz J. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" 1957. "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ET"
    }
  }, [_vm._v("ET")]), _vm._v(", London: Lutterworth, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxii"
    }
  }), _vm._v("Lenski, R. C. H. "), _c('i', [_vm._v("The Interpretation of St. Paul’s Epistle to the Romans.")]), _vm._v(" Minneapolis: Augsburg, 1936.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Liddon, H. P. "), _c('i', [_vm._v("Explanatory Analysis of St. Paul’s Epistle to the Romans.")]), _vm._v(" London: Longmans, Green, 1893.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lietzmann, Hans. "), _c('i', [_vm._v("An die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HNT"
    }
  }, [_vm._v("HNT")]), _vm._v(". Tübingen: Mohr, 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lightfoot, J. B. "), _c('i', [_vm._v("Notes on Epistles of St. Paul.")]), _vm._v(" 1895. Reprint. Grand Rapids: Baker, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lipsius, R. A. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Briefe an die Galater, Römer, Philipper.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HKNT"
    }
  }, [_vm._v("HKNT")]), _vm._v(". Freiburg: Mohr, 1892.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lloyd-Jones, D. M. "), _c('i', [_vm._v("Romans.")]), _vm._v(" 7 vols., variously titled, on chaps. 1 and 3:20–8:39. Grand Rapids: Zondervan, 1970–88.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Luther, Martin. "), _c('i', [_vm._v("Lectures on Romans: Glosses and Scholia.")]), _vm._v(" Luther’s Works 25. St. Louis: Concordia, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Meyer, H. A. W. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MEYERK"
    }
  }, [_vm._v("MeyerK")]), _vm._v(". 2 vols. 1872. Reprint. Edinburgh: T & T Clark, 1881, 1884.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Michel, Otto. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MEYERK"
    }
  }, [_vm._v("MeyerK")]), _vm._v(". Göttingen: Vandenhoeck & Ruprecht, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Morris, Leon. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" Pillar New Testament Commentary. Grand Rapids: Eerdmans, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Moule, H. C. G. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" The Cambridge Bible for Schools and Colleges. Cambridge: Cambridge University, 1887.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Murray, John. "), _c('i', [_vm._v("The Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NICNT"
    }
  }, [_vm._v("NICNT")]), _vm._v(". 2 vols. Grand Rapids: Eerdmans, 1959, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Nygren, Anders. "), _c('i', [_vm._v("Commentary on Romans.")]), _vm._v(" 1944. Reprint. Philadelphia: Fortress, 1949.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("O’Neill, J. C. "), _c('i', [_vm._v("Paul’s Letter to the Romans.")]), _vm._v(" Pelican New Testament Commentaries. Baltimore: Penguin, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Pesch, R. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Römerbrief.")]), _vm._v(" Die neue Echter Bibel. Wurzburg: Echter, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ridderbos, Herman N. "), _c('i', [_vm._v("Aan de Romeinen.")]), _vm._v(" Commentaar op het Nieuwe Testament. Kampen: Kok, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Robinson, John A. T. "), _c('i', [_vm._v("Wrestling with Romans.")]), _vm._v(" Philadelphia: Westminster, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Sanday, William, and Arthur C. Headlam. "), _c('i', [_vm._v("A Critical and Exegetical Commentary on the Epistle to the Romans.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ICC"
    }
  }, [_vm._v("ICC")]), _vm._v(". Edinburgh: T & T Clark, 1902.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schelkle, Karl Hermann. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Paulus, Lehrer der Väter. Die altkirchliche Auslegung von Römer 1–11.")]), _vm._v(" Düsseldorf: Patmos, 1956.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schlatter, Adolf. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Gottes Gerechtigkeit.")]), _vm._v(" Stuttgart: Calwer, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schlier, H. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief Kommentar.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.HTKNT"
    }
  }, [_vm._v("HTKNT")]), _vm._v(". Freiburg: Herder, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmidt, Hans Wilhelm. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief des Paulus an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.THKNT"
    }
  }, [_vm._v("THKNT")]), _vm._v(". Berlin: Evangelische, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schmithals, W. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Römerbrief. Ein Kommentar.")]), _vm._v(" Gütersloh: Mohn, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxiii"
    }
  }), _vm._v("Shedd, William G. T. "), _c('i', [_vm._v("A Critical and Doctrinal Commentary upon the Epistle of St. Paul to the Romans.")]), _vm._v(" New York: Scribner’s, 1879.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Sickenberger, Joseph. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die beiden Briefe des heiligen Paulus an die Korinther und sein Brief an die Römer.")]), _vm._v(" Die Heiligen Schriften des Neuen Testaments. Bonn: Peter Hanstein, 1923.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Smart, James. "), _c('i', [_vm._v("Doorway to a New Age: A Study of Paul’s Letter to the Romans.")]), _vm._v(" Philadelphia: Westminster, 1972.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stuart, Moses. "), _c('i', [_vm._v("A Commentary on the Epistle to the Romans.")]), _vm._v(" Ed. and rev. by R. D. C. Robbins. Andover, MA: Warren F. Draper, 1862.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Stuhlmacher, P. "), _c('i', [_vm._v("Paul’s Letter to the Romans. A Commentary.")]), _vm._v(" Louisville: Westminster/John Knox, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Theodoret, in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.PG"
    }
  }, [_c('i', [_vm._v("PG")])]), _vm._v(" 82.43–226.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Thomas, W. H. Griffith. "), _c('i', [_vm._v("St. Paul’s Epistle to the Romans.")]), _vm._v(" 1946. Reprint. Grand Rapids: Eerdmans, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Tholuck, F. A. G. "), _c('i', [_vm._v("Exposition of St. Paul’s Epistle to the Romans.")]), _vm._v(" Philadelphia: Sorin and Ball, 1844.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Viard, A. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Saint Paul: Epître aux Romains.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SB"
    }
  }, [_vm._v("SB")]), _vm._v(". Paris: Gabalda, 1975.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Wesley, John. "), _c('i', [_vm._v("Explanatory Notes upon the New Testament.")]), _vm._v(" 1754. Reprint. London: Epworth, 1950.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Westcott, Frederick Brooke. "), _c('i', [_vm._v("St. Paul and Justification, being an Exposition of the Teaching in the Epistles to Rome and Galatia.")]), _vm._v(" London: Macmillan, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("*Wilckens, Ulrich. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.EKKNT"
    }
  }, [_vm._v("EKKNT")]), _vm._v(". 3 vols. Neukirchen/Vluyn: Neukirchener and Zürich: Benziger, 1978–81.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zahn, Theodor. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief des Paulus an die Römer.")]), _vm._v(" Leipzig: A. Deichertsche, 1910.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zeller, Dieter. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief an die Römer.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.RNT"
    }
  }, [_vm._v("RNT")]), _vm._v(". Regensburg: Pustet, 1985.")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "BIBLIO.4"
    }
  }, [_vm._v("IV. OTHER SIGNIFICANT WORKS")]), _vm._v(" "), _c('div', {
    staticClass: "references"
  }, [_c('p', {
    staticClass: "rf"
  }, [_vm._v("Beker, J. C. "), _c('i', [_vm._v("Paul the Apostle: The Triumph of God in Life and Thought.")]), _vm._v(" Philadelphia: Fortress, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Bultmann, Rudolf. "), _c('i', [_vm._v("Theology of the New Testament.")]), _vm._v(" 2 vols. New York: Scribner’s, 1951, 1955.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Burton, E. de W. "), _c('i', [_vm._v("Syntax of the Moods and Tenses in New Testament Greek.")]), _vm._v(" 3d ed. Edinburgh: T & T Clark, 1898.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Byrne, Brendan. "), _c('i', [_vm._v("‘Sons of God’—‘Seed of Abraham.’ A Study of the Idea of Sonship of God of All Christians in Paul against the Jewish Background.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ANBIB"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 83. Rome: Pontifical Biblical Institute, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Cambier, J. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("L’Evangile de Dieu selon L’épître aux Romains. Exégèse et "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxiv"
    }
  }), _vm._v("théologie biblique. Vol. I: L’Evangile de la justice et de la grace.")]), _vm._v(" Brussels/Louvain: Desclée de Brouwer, 1967.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Dahl, Nils Alstrup. "), _c('i', [_vm._v("Studies in Paul: Theology for the Early Christian Mission.")]), _vm._v(" Minneapolis: Augsburg, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Davies, W. D. "), _c('i', [_vm._v("Paul and Rabbinic Judaism.")]), _vm._v(" London: SPCK, 1948.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Deidun, T. J. "), _c('i', [_vm._v("New Covenant Morality in Paul.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.ANBIB"
    }
  }, [_vm._v("AnBib")]), _vm._v(" 89. Rome: Pontifical Biblical Institute, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Donfried, Karl P., ed. "), _c('i', [_vm._v("The Romans Debate.")]), _vm._v(" 2d ed. Peabody, MA: Hendrickson, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gamble, Harry, Jr. "), _c('i', [_vm._v("The Textual History of the Letter to the Romans: A Study in Textual and Literary Criticism.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SD"
    }
  }, [_vm._v("SD")]), _vm._v(" 42. Grand Rapids: Eerdmans, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Gundry, R. H. "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Sōma")]), _vm._v(" "), _c('i', [_vm._v("in Biblical Theology with Emphasis on Pauline Anthropology.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SNTSMS"
    }
  }, [_vm._v("SNTSMS")]), _vm._v(" 29. Cambridge: Cambridge University, 1976. Reprint. Grand Rapids: Zondervan, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hagner, Donald A., and Harris, Murray J., eds. "), _c('i', [_vm._v("Pauline Studies: Essays Presented to Professor F. F. Bruce on His 70th Birthday.")]), _vm._v(" Grand Rapids: Eerdmans, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hays, Richard B. "), _c('i', [_vm._v("Echoes of Scripture in the Letters of Paul.")]), _vm._v(" New Haven: Yale University, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Hübner, Hans. "), _c('i', [_vm._v("Law in Paul’s Thought.")]), _vm._v(" Edinburgh: T & T Clark, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Koch, D.-A. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die Schrift als Zeuge des Evangeliums: Untersuchungen zur Verwendung und zum Verständnis der Schrift bei Paulus.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.BZHT"
    }
  }, [_vm._v("BZHT")]), _vm._v(" 69. Tübingen: Mohr, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Kühl, E. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Der Brief des Paulus an die Römer.")]), _vm._v(" Leipzig: Quelle & Meyer, 1913.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Longenecker, Richard N. "), _c('i', [_vm._v("Paul, Apostle of Liberty.")]), _vm._v(" 1964. Reprint. Grand Rapids: Baker, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Lorenzi, Lorenzo de, ed. "), _c('i', [_vm._v("Battesimo e Giustizia in Rom 6 e 8.")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 2. Rome: St. Paul’s Abbey, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, ed. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Die Israelfrage nach Röm 9–11.")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 3. Rome: St. Paul’s Abbey, 1977.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, ed. "), _c('span', {
    staticClass: "l-fre-i"
  }, [_vm._v("Dimensions de la vie chrétienne (Rm 12–13).")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 4. Rome: St. Paul’s Abbey, 1979.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, ed. "), _c('i', [_vm._v("The Law of the Spirit in Rom 7 and 8.")]), _vm._v(" Monographic Series of “Benedictina,” Biblical-ecumenical Section, 1. Rome: St. Paul’s Abbey, 1976.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Luz, U. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Das Geschichtsverständnis bei Paulus.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.BEVT"
    }
  }, [_vm._v("BEvT")]), _vm._v(" 49. Munich: Kaiser, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxv"
    }
  }), _vm._v("Metzger, Bruce M. "), _c('i', [_vm._v("A Textual Commentary on the Greek New Testament.")]), _vm._v(" New York: United Bible Societies, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Minear, Paul S. "), _c('i', [_vm._v("The Obedience of Faith: The Purposes of Paul in the Epistle to the Romans.")]), _vm._v(" London: SCM, 1971.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Moulton, James Hope. "), _c('i', [_vm._v("Prolegomena.")]), _vm._v(" Vol. 1 of "), _c('i', [_vm._v("A Grammar of New Testament Greek.")]), _vm._v(" Edinburgh: T & T Clark, 1908.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Munck, Johannes. "), _c('i', [_vm._v("Paul and the Salvation of Mankind.")]), _vm._v(" 1954. London: SCM, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Ortkemper, F.-J. "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Leben aus dem Glauben: Christliche Grundhaltungen nach Römer 12–13.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NTABH"
    }
  }, [_vm._v("NTAbh")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.N.S"
    }
  }, [_vm._v("n.s.")]), _vm._v(" 14. Münster: Aschendorff, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Piper, John. "), _c('i', [_vm._v("The Justification of God: An Exegetical and Theological Study of Romans 9:1–23.")]), _vm._v(" Grand Rapids: Baker, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Räisänen, Heikki. "), _c('i', [_vm._v("Paul and the Law.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.WUNT"
    }
  }, [_vm._v("WUNT")]), _vm._v(" 29. Tübingen: Mohr, 1983.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Robertson, A. T. "), _c('i', [_vm._v("A Grammar of the Greek New Testament in the Light of Historical Research.")]), _vm._v(" New York: George H. Doran, 1915.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Schoeps, H.-J. "), _c('i', [_vm._v("Paul. The Theology of the Apostle in the Light of Jewish Religious History.")]), _vm._v(" 1959. Philadelphia: Westminster, 1961.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Turner, Nigel. "), _c('i', [_vm._v("Syntax.")]), _vm._v(" Vol. 3 of "), _c('i', [_vm._v("A Grammar of New Testament Greek,")]), _vm._v(" by J. H. Moulton. Edinburgh: T & T Clark, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Watson, Francis. "), _c('i', [_vm._v("Paul, Judaism and the Gentiles: A Sociological Approach.")]), _vm._v(" "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.SNTSMS"
    }
  }, [_vm._v("SNTSMS")]), _vm._v(" 56. Cambridge: Cambridge University, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Westerholm, Stephen. "), _c('i', [_vm._v("Israel’s Law and the Church’s Faith: Paul and His Recent Interpreters.")]), _vm._v(" Grand Rapids: Eerdmans, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zerwick, Maximilian. "), _c('i', [_vm._v("Biblical Greek.")]), _vm._v(" Rome: Pontifical Biblical Institute, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("———, and Grosvenor, Mary. "), _c('i', [_vm._v("A Grammatical Analysis of the Greek New Testament.")]), _vm._v(" Rome: Biblical Institute Press, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "rf"
  }, [_vm._v("Zuntz, G. "), _c('i', [_vm._v("The Text of the Epistles: A Disquisition upon the Corpus Paulinum.")]), _vm._v(" The Schweich Lectures, 1946. London: British Academy, 1953.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed87396","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eernicnt66ro0008.vue
// module id = 75
// module chunks = 0